import React, { useState } from "react";
import classNames from "classnames";
import DeliveryCostsModal from "ReactComponents/DeliveryCostsModalButton/DeliveryCostsModal/delivery-costs-modal";
import IProductDeliveryInfo from "interfaces/IProductDeliveryInfo";

export interface IDeliveryCostsModalButtonProps {
    productDeliveryInfo: IProductDeliveryInfo;
    isTotalButton?: boolean;
}

const DeliveryCostsModalButton: React.FC<IDeliveryCostsModalButtonProps> = ({
    productDeliveryInfo,
    isTotalButton = false
}: IDeliveryCostsModalButtonProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const baseClass = "delivery-costs-modal-button";
    const rootClasses = classNames(baseClass);
    const buttonClasses = classNames({
        "total-button": isTotalButton
    });

    return (
        <>
            <DeliveryCostsModal
                productDeliveryInfo={productDeliveryInfo}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
            <div className={rootClasses}>
                <button type="button" className={buttonClasses} onClick={() => setIsModalOpen(true)}>
                    {isTotalButton ? productDeliveryInfo.LinkTextTotal : productDeliveryInfo.LinkText}
                </button>
            </div>
        </>
    );
};

export default DeliveryCostsModalButton;
